<template>
    <v-dialog v-model="dialog" max-width="80%">
        <template #activator="{ on, attrs }">
            <div v-for="(ex, type) in exporters" class="text-no-wrap">
                <Led :status="ex.status" />
                <a v-bind="attrs" v-on="on">{{type}}</a>
            </div>
        </template>
        <v-card class="pa-5">
            <div class="text-h6 d-flex pb-3">
                Enable database monitoring
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>

            <p>
                Coroot is capable of identifying database-related issues.
                To enable this capability, please install the relevant metric exporters.
            </p>

            <div v-for="(ex, type) in exporters" class="mt-2">
                <div v-if="type === 'postgres'">
                    <div>
                        <Led :status="ex.status" />
                        <span class="font-weight-medium">Postgres</span>
                        (<router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'pg-agent'}}" target="_blank">docs</router-link>)
                    </div>
                    <div class="ml-5">
                        Postgres metrics have been received from {{instrumentedApps(ex)}} of {{$pluralize('application', totalApps(ex), true)}}.
                        <template v-if="instrumentedApps(ex) < totalApps(ex)">
                            Get <span class="font-weight-medium">pg-agent </span>
                            <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'pg-agent', item: 'installation'}}" target="_blank">installed</router-link>
                            for every following application:
                        </template>
                    </div>
                </div>
                <div v-if="type === 'redis'">
                    <div>
                        <Led :status="ex.status" />
                        <span class="font-weight-medium">Redis</span>
                        (<router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'redis-exporter'}}" target="_blank">docs</router-link>)
                    </div>
                    <div class="ml-5">
                        Redis metrics have been received from {{instrumentedApps(ex)}} of {{$pluralize('application', totalApps(ex), true)}}.
                        <template v-if="instrumentedApps(ex) < totalApps(ex)">
                            Get <span class="font-weight-medium">redis-exporter </span>
                            <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'redis-exporter', item: 'installation'}}" target="_blank">installed</router-link>
                            for every following application:
                        </template>
                    </div>
                </div>
                <div v-if="type === 'aws-rds'">
                    <div>
                        <Led :status="ex.status" />
                        <span class="font-weight-medium">AWS RDS</span>
                        (<router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent'}}" target="_blank">docs</router-link>)
                    </div>
                    <div class="ml-5">
                        It appears that AWS RDS is being used in this project.
                        Please ensure that
                        <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent', item: 'installation'}}" target="_blank">aws-agent</router-link>
                        is installed.
                    </div>
                </div>
                <div v-if="type === 'aws-elasticache'">
                    <div>
                        <Led :status="ex.status" />
                        <span class="font-weight-medium">AWS ElastiCache</span>
                        (<router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent'}}" target="_blank">docs</router-link>)
                    </div>
                    <div class="ml-5">
                        It appears that AWS ElastiCache is being used in this project.
                        Please ensure that
                        <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent', item: 'installation'}}" target="_blank">aws-agent</router-link>
                        is installed.
                    </div>
                </div>

                <div v-for="(ok, id) in ex.applications" :key="id" class="ml-5">
                    <Led :status="ok ? 'ok' : 'warning'" />
                    <router-link :to="{name: 'application', params: {projectId, id}}">{{$utils.appId(id).name}}</router-link>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import Led from "@coroot/coroot/src/components/Led.vue";

export default {
    props: {
        projectId: String,
        exporters: Object,
    },

    components: {Led},

    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        totalApps(ex) {
            return Object.keys(ex.applications).length;
        },
        instrumentedApps(ex) {
            return Object.values(ex.applications).filter(ok => ok).length;
        },
    },
}
</script>